module.exports = __webpack_public_path__ + "static/media/WelcomeBackHeader.ba03902e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/WelcomeBackHeader.svg
// module id = 344
// module chunks = 0